/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

import { ContentContext } from "context/contentContext";

/**
 * import components
 */

import { Form__tabulation } from "components/form/form";

/**
 * styled components
 */

const Tabulations = styled.div`
  ${t.mixins.flex()}
`;

/**
 * tabulations component is..
 */

const Form__tabulations = ({ steps, active }) => {
  const { c } = useContext(ContentContext);
  return (
    <Tabulations>
      {steps.map((step, index) => {
        const title = `${c("home.form.step")} ${index + 1} : ${step.title}`;
        const status = index === active;
        const completed = index < active;
        return (
          <Form__tabulation
            key={step.id}
            title={title}
            active={status}
            index={index}
            completed={completed}
          />
        );
      })}
    </Tabulations>
  );
};
export default Form__tabulations;

Form__tabulations.propTypes = {
  /**
      Differents steps
      */
  steps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
